import React, { useContext, useEffect, useState } from 'react'
// import style from './Project.module.css'
import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { LangContext } from '../context/LangContext'
import project1_1 from '../../assets/images/project03.webp'
import project1_2 from '../../assets/images/اختبار test pit.webp'
import project1_3 from '../../assets/images/حفارات 8.webp'
import project2_1 from '../../assets/images/حفارات 5.webp'
import project2_2 from '../../assets/images/حفارات 6.webp'
import project2_3 from '../../assets/images/مشروع الوديان.webp'
import project3_1 from '../../assets/images/00108.webp'
import project3_2 from '../../assets/images/مشروع جدة 1.webp'
import project3_3 from '../../assets/images/مشروع جدة.webp'
import project4_1 from '../../assets/images/اختبار قرص التحميل في مشروع سدرة 2.webp'
import project4_2 from '../../assets/images/روشن - سدرة 2.webp'
import project4_3 from '../../assets/images/روشن 2- سدرة 2.webp'
import project5_1 from '../../assets/images/اختبارات معملية 2.webp'
import project5_2 from '../../assets/images/الجبيل1 (1).webp'
import project5_3 from '../../assets/images/الجبيل1 (2).webp'
import project5_4 from '../../assets/images/WhatsApp Image 2025-02-11 at 9.14.50 PM.webp'
import project5_5 from '../../assets/images/WhatsApp Image 2025-02-11 at 9.14.51 PM.webp'
import project5_6 from '../../assets/images/WhatsApp Image 2025-02-11 at 9.14.54 PM.webp'
import project5_7 from '../../assets/images/WhatsApp Image 2025-02-11 at 9.14.55 PM.webp'
import project5_8 from '../../assets/images/WhatsApp Image 2025-02-11 at 9.14.58 PM.webp'
import project6_1 from '../../assets/images/S4.webp'
import project6_2 from '../../assets/images/أعمال ضبط جودة لأحد مشاريع البنية التحتية.webp'
import project6_3 from '../../assets/images/حرض 3.webp'
import project7_1 from '../../assets/images/احتبارات -قصر الملك خالد.webp'
import project7_2 from '../../assets/images/احتبارات 3 - قصر الملك خالد.webp'
import project7_3 from '../../assets/images/اختبارات 2 - قصر الملك خالد.webp'
import project8_1 from '../../assets/images/ألتراسونك.webp'
import project8_2 from '../../assets/images/كور اسفلت2.webp'
import project8_3 from '../../assets/images/مشروع تبوك صورة 4.webp'
import project9_1 from '../../assets/images/عينات مشروع مبنى التحلية 2.webp'
import project9_2 from '../../assets/images/مبنى التحلية.webp'
import project9_3 from '../../assets/images/مشروع مبنى التحلية.webp'
import project10_1 from '../../assets/images/M6.jpeg.jpg'
import project10_2 from '../../assets/images/M9.jpeg.jpg'
import project10_3 from '../../assets/images/M11.jpeg.jpg'
import projectDesign1_1 from '../../assets/images/مشروع اس1.webp'
import projectDesign1_2 from '../../assets/images/مشروع اس2.webp'
import projectDesign1_3 from '../../assets/images/مشروع اس3.webp'
import projectDesign1_4 from '../../assets/images/مشروع اس4.webp'
import projectDesign2_1 from '../../assets/images/ELEVATION 1.webp'
import projectDesign2_2 from '../../assets/images/ELEVATION 2.webp'
import projectDesign3_1 from '../../assets/images/مشروع اس5.webp'
import projectDesign3_2 from '../../assets/images/مشروع اس6.webp'
import projectDesign3_3 from '../../assets/images/اخر تعديل_2 - Ext Main View.webp'
import projectDesign3_4 from '../../assets/images/تعديل_22 - Photo.webp'
import projectDesign4_1 from '../../assets/images/مبنى الحياة الفطرية_3 - Photo.webp'
import projectDesign4_2 from '../../assets/images/مبنى الحياة الفطرية 3_25 - Photo.webp'
import projectDesign4_3 from '../../assets/images/مبنى الحياة الفطرية_2 - Photo.webp'
import projectDesign4_4 from '../../assets/images/واجهة.webp'
import projectDesign5_1 from '../../assets/images/00001.webp'
import projectDesign6_1 from '../../assets/images/ابو فيصل.webp'
import projectUrban1_1 from '../../assets/images/المخطط المعتمد نهائي 3943 بتاريخ 19-17-2023-Model.webp'
import projectUrban2_1 from '../../assets/images/مخطط ركاز حي السعادة المعدل نهااائي-Model.webp'
import projectUrban3_1 from '../../assets/images/نهائي مخطط رقم 3978 بتاريخ 04 - 08 - 2024 (2)-Model.webp'
import projectUrban4_1 from '../../assets/images/ابوبندر.webp'
import projectUrban5_1 from '../../assets/images/تصميم حضري - حدائق هارد اسكيب.webp'
import projectUrban5_2 from '../../assets/images/تصميم حضري - حدائق-Layout1.webp'
import projectUrban5_3 from '../../assets/images/مخطط الجديدة نهائي-Model.webp'
import projectHydro1_1 from '../../assets/images/elahmar.webp'
import projectHydro1_2 from '../../assets/images/helw.webp'
import projectHydro1_3 from '../../assets/images/log2.webp'
import projectHydro2_1 from '../../assets/images/PHOTO-2023-06-18-15-39-08.webp'
import projectHydro2_2 from '../../assets/images/image00004.webp'
import projectHydro3_1 from '../../assets/images/01hydro.webp'
import projectHydro3_2 from '../../assets/images/02hydro.webp'
import projectHydro3_3 from '../../assets/images/03hydro.webp'
import projectHydro3_4 from '../../assets/images/04hydro.webp'
import projectHydro4_1 from '../../assets/images/Pr-Sloution.webp'
import projectHydro4_2 from '../../assets/images/210.webp'
import projectHydro4_3 from '../../assets/images/43.webp'
import projectHydro4_4 from '../../assets/images/97.webp'
import projectHydro5_1 from '../../assets/images/ااااااااااااااااا_page-0046.webp'
import projectHydro5_2 from '../../assets/images/ااااااااااااااااا_page-0047.webp'
import projectHydro5_3 from '../../assets/images/ااااااااااااااااا_page-0051.webp'
import projectGis1_1 from '../../assets/images/WhatsApp Image 2023-04-01 at 15.30.45.webp'
import projectGis1_2 from '../../assets/images/WhatsApp Image 2024-09-30 at 13.20.34_3a0b641b.webp'
import projectGis2_1 from '../../assets/images/WhatsApp Image 2023-04-01 at 15.50.49.webp'
import projectGis2_2 from '../../assets/images/100100001000.webp'
import projectGis2_3 from '../../assets/images/WhatsApp Image 2023-04-01 at 15.26.58.webp'
import projectGis2_4 from '../../assets/images/WhatsApp Image 2023-04-11 at 10.14.32.webp'
import projectGis3_1 from '../../assets/images/IMG-20230420-WA0097.webp'
import projectGis3_2 from '../../assets/images/WhatsApp Image 2023-04-11 at 10.17.56.webp'
import projectSuper1_1 from '../../assets/images/IMG-20230802-WA0103.webp'
import projectSuper1_2 from '../../assets/images/IMG-20230802-WA0068.webp'
import projectSuper1_3 from '../../assets/images/IMG-20230802-WA0094.webp'
import projectSuper1_4 from '../../assets/images/WhatsApp Image 2023-10-05 at 9.51.18 AM (1).webp'
// import projectSuper2_ from '../../assets/images/المشاريع - الإشراف على التنفيذ/'
import projectSuper3_1 from '../../assets/images/IMG-20241121-WA0042.webp'
import projectSuper3_2 from '../../assets/images/IMG-20241121-WA0039.webp'
import projectSuper3_3 from '../../assets/images/IMG-20241121-WA0050.webp'
import projectSuper3_4 from '../../assets/images/WhatsApp Image 2024-09-30 at 11.06.58_cc08f816.webp'
// import projectSuper4_ from '../../assets/images/المشاريع - الإشراف على التنفيذ/'
// import projectSuper5_ from '../../assets/images/المشاريع - الإشراف على التنفيذ/'
// import projectSuper6_ from '../../assets/images/المشاريع - الإشراف على التنفيذ/'
import projectSuper7_1 from '../../assets/images/اعتماد المخططات لخزان الغويري_Page_01.webp'
import projectSuper7_2 from '../../assets/images/اعتماد المخططات لخزان الغويري_Page_03.webp'
import projectSuper7_3 from '../../assets/images/اعتماد المخططات لخزان الغويري_Page_04.webp'
import projectSuper7_4 from '../../assets/images/اعتماد المخططات لخزان الغويري_Page_10.webp'
import projectInfra1_1 from '../../assets/images/WhatsApp Image 2024-03-05 at 7.39.58 AM.webp'
import projectInfra1_2 from '../../assets/images/WhatsApp Image 2024-03-05 at 7.39.59 AM (1).webp'
import projectInfra1_3 from '../../assets/images/WhatsApp Image 2024-03-05 at 7.40.00 AM (1).webp'
import projectInfra1_4 from '../../assets/images/WhatsApp Image 2024-03-05 at 7.40.00 AM.webp'
import projectInfra2_1 from '../../assets/images/حرمة-Main.webp'
import projectInfra3_1 from '../../assets/images/100infra.webp'
import projectInfra4_1 from '../../assets/images/العنود.webp'
import projectInfra4_2 from '../../assets/images/بي.webp'
import projectInfra5_1 from '../../assets/images/5infraa.webp'
import projectInfra5_2 from '../../assets/images/7infra.webp'
import projectInfra5_3 from '../../assets/images/8infra.webp'
import projectInfra6_1 from '../../assets/images/10infra.webp'
import projectInfra6_2 from '../../assets/images/5infra.webp'
import projectInfra6_3 from '../../assets/images/69infra.webp'
import projectInfra6_4 from '../../assets/images/71infra.webp'
import projectInfra7_1 from '../../assets/images/4infra.webp'
import projectTrans1_1 from '../../assets/images/21trans.webp'
import projectTrans1_2 from '../../assets/images/22trans.webp'
import projectTrans1_3 from '../../assets/images/226.webp'
import projectTrans1_4 from '../../assets/images/25.webp'
import projectTrans2_1 from '../../assets/images/124.webp'
import projectTrans2_2 from '../../assets/images/238.webp'
import projectTrans2_3 from '../../assets/images/252.webp'
import projectTrans2_4 from '../../assets/images/5trans.webp'
import projectTrans3_1 from '../../assets/images/110.webp'
import projectTrans3_2 from '../../assets/images/5transs.webp'
import projectTrans3_3 from '../../assets/images/6trans.webp'
import projectTrans3_4 from '../../assets/images/60.webp'
import projectElectrical1_1 from '../../assets/images/WhatsApp Image 2024-07-28 at 8.49.54 PM.webp'
import projectElectrical1_2 from '../../assets/images/WhatsApp Image 2024-07-28 at 8.51.18 PM.webp'
import projectElectrical1_3 from '../../assets/images/WhatsApp Image 2024-07-28 at 8.53.11 PM.webp'
import projectElectrical1_4 from '../../assets/images/WhatsApp Image 2024-09-22 at 16.51.35_4b6a3ffc.webp'
import projectEvaluation1_1 from '../../assets/images/020.webp'
import projectEvaluation1_2 from '../../assets/images/WhatsApp Image 2022-12-03 at 11.09.24 AM (1).webp'
import projectEvaluation1_3 from '../../assets/images/WhatsApp Image 2022-12-03 at 11.09.40 AM.webp'
import projectEvaluation1_4 from '../../assets/images/WhatsApp Image 2022-12-03 at 11.10.18 AM.webp'
import projectEvaluation2_1 from '../../assets/images/مشروع تبوك صورة 4.webp'
import projectEvaluation2_2 from '../../assets/images/WhatsApp Image 2024-10-02 at 17.51.43_88522000.webp'
import projectEvaluation2_3 from '../../assets/images/مشروع تبوك صورة 1.webp'
import projectEvaluation2_4 from '../../assets/images/مشروع تبوك صورة 2.webp'
import projectEvaluation3_1 from '../../assets/images/WhatsApp Image 2022-06-23 at 1.09.57 PM.webp'
import projectEvaluation3_2 from '../../assets/images/WhatsApp Image 2022-06-15 at 1.12.36 PM (5).webp'
import projectEvaluation3_3 from '../../assets/images/photo_2024-07-25_11-10-56.webp'
import labsLogo from '../../assets/images/logo-mekyal-saudi.webp'
import engLogo from '../../assets/images/Picture1-150x150.webp'
import { Helmet } from 'react-helmet'
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/autoplay"
import 'swiper/css/pagination'
import 'swiper/swiper-bundle.css';
import { Autoplay ,Pagination } from 'swiper/modules'
import api from '../../api/api'
import LoadingP from '../Loading/LoadingP.jsx'

export default function Project() {
  
  const { t } = useTranslation()
  let {language}= useContext(LangContext)
  const site = sessionStorage.getItem('desiredPage')
  let {id} = useParams()
  const [loading, setLoading] = useState(false)
  const [project, setProject] = useState(null)
  const [relatedProjects, setRelatedProjects] = useState([]);
  // const [category, setCategory] = useState([]);
  const [projects, setProjects] = useState([]);

  const companyProjects = [
    {
      id: '9661',
      name:'تصميم مبنى الدفاع المدني بالمدينة المنورة',
      category: { id: 16, name: t("navArchitectural")},
      customer: 'الدفاع المدني بالمدينة المنورة',
      text: '',
      text2: '',
      work_scope: 'تصميم جميع المخططات المعمارية والإنشائية والإلكتروميكانيكية واستخراج رخصة بناء',
      work_scope_points: [],
      points: [],
      execution_year:'2019',
      start_date: null,
      images: [projectDesign1_1,projectDesign1_2,projectDesign1_3,projectDesign1_4]
    },
    {
      id: '9662',
      name:'إعادة تصميم واجهات مباني الجمارك بمعبر البطحاء',
      category: { id: 16, name: t("navArchitectural")},
      customer: 'هيئة الزكاة والضريبة والجمارك',
      text: '',
      text2: '',
      work_scope: 'إعادة تصميم واجهات لمباني قائمة عدد 18 مبنى متعددة الأدوار بالإضافة إلي أعمال الرفع المساحي',
      work_scope_points: [],
      points: [],
      execution_year:'2021',
      start_date: null,
      images: [projectDesign2_1,projectDesign2_2]
    },
    {
      id: '9663',
      name:'تصميم جامع الأمير سلطان بن عبد العزيز آل سعود وملحقاته ',
      category: { id: 16, name: t("navArchitectural")},
      customer: 'جمعية الأمير سلطان بن عبد العزيز آل سعود',
      text: '',
      text2: '',
      work_scope: 'يشمل نطاق العمل تصميم مسجد بطاقة استيعابية تصل إلى 900 مصلٍ، بمساحة إجمالية تبلغ 500 متر مربع، إضافة إلى الإشراف الكامل على تنفيذ المشروع منذ بدايته وحتى تسليمه، ويشمل:',
      work_scope_points: [
        'إعداد جميع المخططات المعمارية، الإنشائية، والإلكتروميكانيكية وفق أعلى معايير الجودة.',
        'تصميم البنية التحتية للمشروع، بما يشمل أنظمة الصرف الصحي، شبكات المياه والكهرباء، وأنظمة التكييف والتهوية.',
        'تصميم العناصر الجمالية للمشروع، مثل الواجهات الخارجية والزخارف الداخلية، مع مراعاة الطابع الإسلامي التقليدي الممزوج بالحداثة.',
        'إعداد المخططات التفصيلية للمبنى الرئيسي وعدد 2 فيلا ملحقة بالمسجد، تتضمن المساحات السكنية والخدمات.',
        'التخطيط لتوفير المرافق الخدمية مثل مواقف السيارات، المساحات الخضراء، وأماكن الوضوء.',
        'الإشراف على تنفيذ المشروع بجميع مراحله، بما يضمن تحقيق جودة الأعمال ومطابقتها للتصاميم والاشتراطات الفنية والهندسية.',
        'التنسيق مع جميع الأطراف المعنية، بما في ذلك المقاولين والموردين، لضمان سير العمل وفق الجداول الزمنية المحددة.',
        'اعتماد استخدام تقنيات التصميم المستدام لتحسين كفاءة الطاقة وتقليل التأثير البيئي للمشروع.',
      ],
      points: [],
      execution_year: null,
      start_date:'2022',
      images: [projectDesign3_1,projectDesign3_2,projectDesign3_3,projectDesign3_4]
    },
    {
      id: '9664',
      name:'تصميم مكاتب إدارة التراخيص للحياة الفطرية (مركز الإيواء المؤقت بمنطقة جازان)',
      category: { id: 16, name: t("navArchitectural")},
      customer: 'المركز الوطني لتنمية الحياة الفطرية',
      text:'قام المكيال السعودي للاستشارات الهندسية بتصميم مكاتب إدارة التراخيص للاتجار بالكائنات الفطرية في أسواق منطقة جازان. ',
      text2: null,
      work_scope: 'شمل نطاق العمل تصميم المكاتب والمرافق المتصلة بها مع مراعاة تحقيق أعلى مستويات الكفاءة التشغيلية. تمحور التصميم حول:',
      work_scope_points: [
        'تصميم المكاتب الإدارية: تطوير تصاميم مكاتب تتسم بالمرونة والفاعلية لضمان سير العمل بكفاءة عالية، مع توفير بيئة ملائمة لموظفي الإدارة.',
      ],
      points : [
        {point:'تخطيط المساحات',
          text:'تخصيص المساحات المناسبة لتسهيل عمليات تقديم الطلبات والتراخيص، فضلاً عن مواقف السيارات، وحلول التخزين الآمنة للوثائق.'
        },
      ],
      execution_year:'2023',
      start_date: null,
      images: [projectDesign4_1,projectDesign4_2,projectDesign4_3,projectDesign4_4]
    },
    {
      id: 'examples/01',
      name:'تصميم مجموعة من محطات الوقود',
      category: { id: 16, name: t("navArchitectural")},
      customer: 'محطات الدريس، بترومترك،  Seven Plus، وعدد من الأفراد بمختلف مدن منطقة الرياض',
      text: '',
      text2: '',
      work_scope: 'تصميم جميع المخططات المعمارية والإنشائية والإلكتروميكانيكية واعتماد واستخراج رخص بناء.',
      work_scope_points: [],
      points: [],
      execution_year: null,
      start_date: null,
      images: [projectDesign5_1]
    },
    {
      id: 'examples/02',
      name:'تصميم العديد من الفلل والعمائر السكنية',
      category: { id: 16, name: t("navArchitectural")},
      customer: 'أفراد ومطورون عقاريون',
      text: '',
      text2: '',
      work_scope: 'إعداد الرفع المساحي والمخططات المعمارية والإنشائية واستخراج رخص البناء',
      work_scope_points: [],
      points: [],
      execution_year: null,
      start_date: null,
      images: [projectDesign6_1]
    },
    {
      id: '9667',
      name:'تخطيط واعتماد نهائي للمخطط رقم 3978 بحي الرمال بالرياض',
      category: { id: 16, name: t("navArchitectural")},
      customer: 'شركة بذل العقارية',
      text: '',
      text2: '',
      work_scope: 'اعتماد نهائي وأعمال فرز للمخطط',
      work_scope_points: [],
      points: [],
      execution_year:'2024',
      start_date: null,
      images: [projectUrban1_1]
    },
    {
      id: '9668',
      name:'تخطيط واعتماد نهائي للمخطط رقم 3957 بحي السعادة بالرياض ',
      category: { id: 16, name: t("navArchitectural")},
      customer: 'شركة ركاز العقارية',
      text: '',
      text2: '',
      work_scope: 'اعتماد نهائي من أمانة منطقة الرياض وأعمال الفرز للمخطط',
      work_scope_points: [],
      points: [],
      execution_year:'2023',
      start_date: null,
      images: [projectUrban2_1]
    },
    {
      id: '9669',
      name:'تخطيط واعتماد نهائي للمخطط رقم 3943 بحي الجنادرية بالرياض',
      category: { id: 16, name: t("navArchitectural")},
      customer: 'شركة تساوي العقارية ',
      text: '',
      text2: '',
      work_scope: 'اعتماد نهائي من أمانة منطقة الرياض وأعمال الهوية العقارية والفرز للمخطط',
      work_scope_points: [],
      points: [],
      execution_year:'2023',
      start_date: null,
      images: [projectUrban3_1]
    },
    {
      id: '96610',
      name:'تخطيط مدينة صناعية بمحافظة الخرج',
      category: { id: 16, name: t("navArchitectural")},
      customer: 'مطور عقاري',
      text: '',
      text2: '',
      work_scope: 'تخطيط وتصميم الفكرة التخطيطية وإعتمادها وأعمال الفرز',
      work_scope_points: [],
      points: [],
      execution_year:'2024',
      start_date: null,
      images: [projectUrban4_1]
    },
    {
      /////////////////////////////////////////////
      id: '96611',
      name:'التصميم الحضري',
      category: { id: 16, name: t("navArchitectural")},
      customer: '',
      text: '',
      text2: '',
      work_scope: '',
      work_scope_points: [],
      points: [],
      execution_year: null,
      start_date: null,
      images: [projectUrban5_1,projectUrban5_2,projectUrban5_3]
    },
    {
      id: '96612',
      name:'إعداد الدراسات الهيدرولوجية لبلديات المحور الجنوبي بمنطقة الرياض',
      category: { id: 7, name: t("navHydrological")},
      customer: 'أمانة منطقة الرياض الوكالة المساعدة لمشاريع بلديات منطقة الرياض',
      text: 'تولى المكيال السعودي للاستشارات الهندسية إعداد الدراسات الهيدرولوجية المتخصصة لعدد من الأراضي والمخططات الواقعة ضمن نطاق بلديات المحور الجنوبي في منطقة الرياض. هدفت هذه الدراسات إلى تحليل الموارد المائية ومجاري الأودية، وتقييم مخاطر السيول، ووضع الحلول الهندسية المستدامة لحماية المناطق المستهدفة وتعزيز الاستفادة المثلى من الموارد الطبيعية.',
      text2:'تمحور العمل حول تحقيق التكامل بين تخطيط الأراضي وإدارة الموارد المائية، مع مراعاة المعايير البيئية والتنموية، مما ساهم في تقديم حلول فعالة لدعم استدامة المنطقة وتلبية احتياجاتها المستقبلية.',
      work_scope: '',
      work_scope_points: [],
      points: [
        {point:'النطاق الجغرافي لعمل المشروع والبلدات المستفيدة من المشروع',
        points: [
          {point:'بلدية الخرج'},
          {point:'بلدية الدلم'},
          {point:'بلدية حوطة بني تميم'},
          {point:'بلدية الحلوة'},
          {point:'بلدية الحريق'},
          {point:'بلدية الأفلاج'},
          {point:'بلدية البديع الأحمر'},
          {point:'بلدية السليل'},
          {point:'بلدية وادي الدواسر'},
        ]
        }],
      execution_year: null,
      start_date: null,
      images: [projectHydro1_1,projectHydro1_2,projectHydro1_3]
    },
    {
      id: '96613',
      name:'دراسة وإعداد وتطوير الكود السعودي لمصادر المياه واستخداماتها',
      category: { id: 7, name: t("navHydrological")},
      customer: 'وزارة البيئة والمياه والزراعة',
      text: 'تولى المكيال السعودي للاستشارات الهندسية إعداد وتطوير استراتيجيات مستدامة تهدف إلى تحسين إدارة مصادر المياه وتعزيز كفاءة استخدامها في مختلف القطاعات. يأتي هذا المشروع كجزء من الجهود الوطنية الرامية إلى تحقيق الاستدامة البيئية وترشيد استهلاك الموارد المائية بما يتماشى مع رؤية المملكة 2030.',
      text2: 'ساهم المشروع في تمكين القطاعات المختلفة من اتباع ممارسات مستدامة، ما أدى إلى تحسين كفاءة استهلاك المياه ودعم الجهود الوطنية لمواجهة التحديات المتعلقة بندرة المياه وضمان استدامة هذا المورد الحيوي للأجيال القادمة.',
      work_scope: 'تمحور المشروع حول تطوير الكود السعودي لمصادر المياه واستخداماتها، والذي يُعد أداة تنظيمية ورؤية استراتيجية تضع معايير واضحة وشاملة لإدارة المياه بكفاءة. وشمل العمل:',
      work_scope_points: [
        'وضع السياسات والمبادئ التوجيهية لتقييم مصادر المياه وإعادة استخدامها.',
        'تقديم حلول مبتكرة وتقنيات متطورة لتحسين كفاءة استخدام المياه في القطاعات الزراعية، والصناعية، والحضرية.',
        'مراعاة الجوانب البيئية والاقتصادية لتحقيق التوازن بين الطلب على المياه والحفاظ على الموارد الطبيعية.',
      ],
      points: [],
      execution_year: null,
      start_date: null,
      images: [projectHydro2_1,projectHydro2_2]
    },
    {
      id: '96614',
      name:'العديد من الدراسات الجزئية مع أمانة منطقة الرياض ووكالة الأمانة ووزارة النقل وغيرها من الجهات ',
      category: { id: 7, name: t("navHydrological")},
      customer: '',
      text: '',
      text2: '',
      work_scope: '',
      work_scope_points: [],
      points: [],
      execution_year: null,
      start_date: null,
      images: [projectHydro5_1,projectHydro5_2,projectHydro5_3]
    },
    {
      id: '96615',
      name:'الدراسة الهيدرولوجية لمشروع تصميم وتنفيذ تحويلة طريق الملك خالد التابع لبوابة الدرعية',
      category: { id: 7, name: t("navHydrological")},
      customer: '',
      text: 'قام المكيال السعودي للاستشارات الهندسية بتنفيذ دراسة هيدرولوجية لمشروع تصميم وتنفيذ تحويلة طريق الملك خالد. تهدف الدراسة إلى تحليل جريان المياه وتحديد الحلول المثلى للتصريف المائي على طول الطريق، بما يضمن سلامة الطريق وتقليل المخاطر الناتجة عن الأمطار والسيول.',
      text2:'ساهمت هذه الدراسة في تأمين تصميم هندسي يعالج تحديات التصريف المائي بشكل شامل، مما يسهم في تحسين استدامة الطريق وضمان سلامته على المدى الطويل.',
      work_scope: '',
      work_scope_points: [
        'تحليل جريان المياه: دراسة وتحليل تأثيرات الأمطار على المنطقة المحيطة بطريق الملك خالد، وتحديد مناطق التجمع المائي لتصميم حلول تصريف فعّالة.',
        'دراسة التأثيرات الهيدرولوجية: تحديد كيفية تأثير تحويلة الطريق على تدفق المياه في المنطقة، بما في ذلك التغيرات المحتملة في اتجاهات الجريان وأثرها على التصميم العام.',
        'اقتراح حلول التصريف: وضع حلول هندسية مبتكرة للتصريف الفعّال للمياه عبر شبكة من الخنادق، المجاري المائية، وحلول محطات ضخ المياه، لضمان استمرارية الحركة على الطريق في مختلف الظروف المناخية.',
        'التصميم البيئي: ضمان أن التصميم يتماشى مع المعايير البيئية ويقلل من التأثيرات السلبية على البيئة المحيطة.',
      ],
      points: [],
      execution_year: null,
      start_date: null,
      images: [projectHydro3_1,projectHydro3_2,projectHydro3_3,projectHydro3_4]
    },
    {
      id: '96616',
      name:'تقديم خدمات الدراسة الهيدرولوجية والأعمال المساحية لمواقع متفرقة بالرياض ',
      category: { id: 7, name: t("navHydrological")},
      customer: '',
      text: 'قام المكيال السعودي للاستشارات الهندسية بتنفيذ المرحلة الثانية من مشروع تطوير البنية التحتية لمنطقة الرياض التي تشمل الدراسات الهيدرولوجية والأعمال المساحية لمواقع متفرقة على الطرق الرئيسية والفرعية. تم تنفيذ هذه الدراسات بهدف اقتراح الحلول المثلى ووسائل التصريف الفعالة للمياه، بما يساهم في تعزيز السلامة البيئية وتحسين شبكة الطرق في المناطق المستهدفة.',
      text2: '',
      work_scope: 'شمل نطاق المشروع المواقع التالية ضمن منطقة الرياض: (الرياض – القرين – الخرج- وادي الدواسر – الدلم - الأحمر – الرين - الأفلاج – الحصاة - شقراء – نفي- الطريف).',
      work_scope_points: [
        'الدراسات الهيدرولوجية: تحليل جريان المياه في المناطق المختلفة، وتحديد مصادر الأمطار والمجاري المائية، وتقديم حلول هندسية لمعالجة مشاكل تجمع المياه وتوجيهها بشكل فعال.',
        'الأعمال المساحية: إجراء مسوحات دقيقة لتحديد مواقع التصريف وتقييم المخاطر المحتملة، بما يضمن توفير تصريف مناسب وفقًا للطبيعة الجغرافية للمنطقة.',
      ],
      points: [
        {point:'اقتراح الحلول',
          text:'تصميم أنظمة تصريف المياه بما يتماشى مع المعايير الفنية الحديثة لضمان التخفيف من تأثيرات الفيضانات والسيول على الطرق والبنية التحتية.'
        },
      ],
      execution_year: null,
      start_date: null,
      images: [projectHydro4_1,projectHydro4_2,projectHydro4_3,projectHydro4_4]
    },
    {
      id: '96617',
      name:'أعمال رفع المساحة وتثبيت بتر حدودية لوكالة الثروة السمكية التابعة لوكالة الزراعة بمنطقة مكة المكرمة',
      category: { id: 8, name: t("navGIS")},
      customer: '',
      text: '',
      text2: '',
      work_scope: '',
      work_scope_points: [],
      points: [],
      execution_year: null,
      start_date: null,
      images: [projectGis1_1,projectGis1_2]
    },
    {
      id: '96618',
      name:'اعمل الرفع المساحي وإنشاء بتر حدودية لتحديد ميدان تدريب للحرس الوطني',
      category: { id: 8, name: t("navGIS")},
      customer: '',
      text: '',
      text2: '',
      work_scope: '',
      work_scope_points: [],
      points: [],
      execution_year: null,
      start_date: null,
      images: [projectGis2_1,projectGis2_2,projectGis2_3,projectGis2_4]
    },
    {
      id: '96619',
      name:'أعمال التخطيط والرفع المساح وتبتير الأراضي للمخططات السكنية لأعمال خاصة بوزارة البلديات والإسكان',
      category: { id: 8, name: t("navGIS")},
      customer: '',
      text: '',
      text2: '',
      work_scope: '',
      work_scope_points: [],
      points: [],
      execution_year: null,
      start_date: null,
      images: [projectGis3_1,projectGis3_2]
    },
    {
      id: '96620',
      name:'الأشراف على أعمال البنية التحتية للمخطط رقم 4002',
      category: { id: 9, name: t("navSupervision")},
      customer: '',
      text: '',
      text2: '',
      work_scope: '',
      work_scope_points: [],
      points: [],
      execution_year: null,
      start_date: null,
      images: [projectSuper1_1,projectSuper1_2,projectSuper1_3,projectSuper1_4]
    },
    {
      id: '96621',
      name:'الأشراف على أعمال البنية التحتية للمخطط رقم 3926',
      category: { id: 9, name: t("navSupervision")},
      customer: '',
      text: '',
      text2: '',
      work_scope: '',
      work_scope_points: [],
      points: [],
      execution_year: null,
      start_date: null,
      images: []
    },
    {
      id: '96622',
      name:'الأشراف على أعمال البنية التحتية للمخطط رقم 3978',
      category: { id: 9, name: t("navSupervision")},
      customer: '',
      text: '',
      text2: '',
      work_scope: '',
      work_scope_points: [],
      points: [],
      execution_year: null,
      start_date: null,
      images: [projectSuper3_1,projectSuper3_2,projectSuper3_3,projectSuper3_4]
    },
    {
      id: '96623',
      name:'الأشراف على أعمال البنية التحتية للمخطط رقم 3079',
      category: { id: 9, name: t("navSupervision")},
      customer: '',
      text: '',
      text2: '',
      work_scope: '',
      work_scope_points: [],
      points: [],
      execution_year: null,
      start_date: null,
      images: []
    },
    {
      id: '96624',
      name: 'اتفاقية إطارية مع وزارة الاستثمار لتقديم الخدمات الهندسية الاستشارية',
      category: { id: 9, name: t("navSupervision")},
      customer: '',
      text: 'أبرمت شركة المكيال السعودي للاستشارات الهندسية اتفاقية إطارية مع وزارة الاستثمار لتقديم مجموعة من الخدمات الهندسية الاستشارية التي تسهم في تحقيق رؤية الوزارة لتطوير مشاريعها وتعزيز البنية التحتية الوطنية.',
      text2: 'الإشراف الهندسي: متابعة وتنفيذ الأعمال الهندسية للمشاريع، مع ضمان الالتزام بالخطط الزمنية والمعايير الإنشائية.',
      work_scope: '',
      work_scope_points: [
        'تصميم مشاريع الوزارة: تطوير التصاميم الهندسية وفق أعلى المعايير الفنية العالمية، مع مراعاة متطلبات الجودة والابتكار لتلبية احتياجات المشاريع.',
        'الإشراف الهندسي: متابعة وتنفيذ الأعمال الهندسية للمشاريع، مع ضمان الالتزام بالخطط الزمنية والمعايير الإنشائية.',
      ],
      points: [],
      execution_year: null,
      start_date: null,
      images: []
    },
    {
      id: '96625',
      name: 'توفير طاقم دعم وإشراف فني للمكتب الإقليمي في المنطقة الشرقية شركة تطوير للمباني (TBC)',
      category: { id: 9, name: t("navSupervision")},
      customer: '',
      text: 'قامت شركة المكيال السعودي للاستشارات الهندسية بتوفير طاقم دعم وإشراف فني متخصص للعمل في المكتب الإقليمي بالمنطقة الشرقية. جاء ذلك في إطار تعزيز قدرة الشركة على تقديم خدمات استشارية متميزة ودعم المشاريع الهندسية في المنطقة، بما يضمن تنفيذ الأعمال بكفاءة عالية ووفق المعايير الفنية.',
      text2: '',
      work_scope: '',
      work_scope_points: [
        'تقديم الاستشارات الفنية المتخصصة لدعم فرق العمل المحلية.',
        'الإشراف على تنفيذ الأعمال والمشاريع لضمان التزامها بالجداول الزمنية والميزانيات المحددة.',
        'دعم التعاون المستمر مع العملاء والمقاولين المحليين لتسهيل العمليات الهندسية.',
      ],
      points: [],
      execution_year: null,
      start_date: null,
      images: []
    },
    {
      id: '96626',
      name: 'مشروع تنفيذ خزان مياه عالي بسعة 200 م³',
      category: { id: 9, name: t("navSupervision")},
      customer: 'الجمعية الخيرية لخدمات المياه (إرواء)',
      text: 'الإشراف على تنفيذ خزان مياه عالي بسعة 200 م³ في مركز عقلة الغويري بمحافظة الدوادمي، ضمن منطقة الرياض. ',
      text2: '',
      work_scope: '',
      work_scope_points: [
        'الإشراف الهندسي الكامل على المشروع لضمان الالتزام بالمواصفات الفنية والمعايير الهندسية.',
        'تقديم الدعم الفني اللازم خلال جميع مراحل تنفيذ المشروع.',
        'تنفيذ الأعمال الإنشائية والكهروميكانيكية للخزان.',
        'التنسيق مع جميع الأطراف المعنية لضمان سير العمل وفق الجدول الزمني المخطط له.',
        'الالتزام بأعلى معايير السلامة والجودة أثناء التنفيذ.',
      ],
      points: [
        {point:'أهداف المشروع',
          points:[
            {point:'تحسين خدمات المياه في المنطقة بشكل مستدام.'},
            {point:'دعم جهود الجمعية الخيرية لخدمات المياه (إرواء) في تحقيق رسالتها لخدمة المجتمع.'},
          ]
        }
      ],
      execution_year: null,
      start_date: null,
      images: [projectSuper7_1,projectSuper7_2,projectSuper7_3,projectSuper7_4]
    },
    {
      id: '96627',
      name: 'الرياض الخضراء',
      category: { id: 10, name: t("navInfrastructure")},
      customer: 'الهيئة الملكية لمدينة الرياض ',
      text: '',
      text2: '',
      work_scope: ' تصميم شبكات الري وأعمال الهندسية الكاملة للبنية التحتية مع نظام الإسكادا',
      work_scope_points: [],
      points: [],
      execution_year: null,
      start_date: null,
      images: [projectInfra1_1,projectInfra1_2,projectInfra1_3,projectInfra1_4]
    },
    {
      id: '96628',
      name: 'مخطط حرمة السكني',
      category: { id: 10, name: t("navInfrastructure")},
      customer: 'الشركة الوطنية للإسكان',
      text: '',
      text2: '',
      work_scope: 'تصميم جميع خدمات البنية التحتية فيه ويشمل ذلك تصميم الطرق، شبكات السيول، شبكة الصرف الصحي، شبكة المياه وشبكة الكهرباء',
      work_scope_points: [],
      points: [],
      execution_year: null,
      start_date: null,
      images: [projectInfra2_1]
    },
    {
      id: '96629',
      name: 'النخيل مول',
      category: { id: 10, name: t("navInfrastructure")},
      customer: 'شركة أوج القابضة',
      text: '',
      text2: '',
      work_scope: 'تصميم خدمات البنية التحتية من تصميم الطرق، شبكات السيول، شبكة الصرف الصحي، شبكة المياه وشبكة الكهرباء.',
      work_scope_points: [],
      points: [],
      execution_year: null,
      start_date: null,
      images: [projectInfra3_1]
    },
    {
      id: '96630',
      name: 'مجمع العنود السكني',
      category: { id: 10, name: t("navInfrastructure")},
      customer: 'شركة دور للضيافة',
      text: '',
      text2: '',
      work_scope: 'تصميم أعمال البنية التحتية طرق صرف صحي شبكة مياه شبكة كهرباء.',
      work_scope_points: [],
      points: [],
      execution_year: null,
      start_date: null,
      images: [projectInfra4_1,projectInfra4_2]
    },
    {
      id: '96631',
      name: 'تصميم ري وزراعة نظام التحكم للرمال 1 والعريضة 2 وحدائق بدر',
      category: { id: 10, name: t("navInfrastructure")},
      customer: '',
      text: 'قام المكيال السعودي بتنفيذ أعمال تصميم شبكات الري وزراعة نظام التحكم لمجموعة من الحدائق في منطقة الرياض في إطار تحسين البيئة الحضرية وتطوير المساحات الخضراء.',
      text2: '',
      work_scope: 'تمحور المشروع حول تطوير حلول ري متكاملة ومستدامة تساهم في تحقيق إدارة فعالة للمياه وضمان استدامة المساحات الخضراء. وقد شمل نطاق العمل:',
      work_scope_points: [
        'تصميم شبكات الري: تطوير وتصميم شبكات ري متطورة تتماشى مع احتياجات كل من الحدائق، مع مراعاة كفاءة استهلاك المياه وتحقيق أقصى استفادة من الموارد المتاحة.',
        'خزانات الري: تصميم خزانات لتخزين المياه اللازمة للري مع ضمان قدرتها على تلبية الاحتياجات طويلة المدى.',
        'أنظمة التحكم: تقديم حزمة متكاملة من أنظمة التحكم الخاصة بإدارة وتنظيم توزيع المياه بما يضمن التشغيل الأمثل للشبكة في جميع الأوقات.',
        'محطات معالجة التناضح العكسي: تصميم محطات معالجة مياه التناضح العكسي لتحلية المياه وإعادة استخدامها في الري، بما يعزز الاستدامة البيئية.',
      ],
      points: [
        {point:'الخزانات لثلاث حدائق',
          text:'تصميم وتطوير خزانات المياه لثلاث حدائق هي: الرمال 1، العريضة 2، وحدائق بدر، لضمان استمرارية توفير المياه دون انقطاع'
        }
      ],
      execution_year: null,
      start_date: null,
      images: [projectInfra5_1,projectInfra5_2,projectInfra5_3]
    },
    {
      id: '96632',
      name: 'تصميم رأسي وهندسي لطريق الوصول إلى ضبا وشقري واتصاله بالطريق السريع المجاور في نيوم',
      category: { id: 10, name: t("navInfrastructure")},
      customer: '',
      text: 'قام المكيال السعودي للاستشارات الهندسية بتقديم خدمات التصميم الهندسي والرأسي لطريق الوصول إلى ضبا وشقري، مع تصميم شامل يهدف إلى تحقيق التواصل الفعال بين المنطقة والطريق السريع المجاور. تمحور هذا المشروع حول توفير مسار آمن وفعال يربط بين المناطق المستهدفة والطريق السريع، ويعزز من سهولة التنقل وتدفق الحركة المرورية في المنطقة.',
      text2: '',
      work_scope: '',
      work_scope_points: [
        'التصميم الرأسي للطريق: وضع التصاميم الخاصة بتحديد المنحدرات والأبعاد الطولية للطريق بما يتناسب مع طبيعة المنطقة الجغرافية ويسهم في تحسين سلامة القيادة.',
        'التصميم الهندسي للطريق: تقديم حلول هندسية شاملة تضمن سلاسة الحركة المرورية على الطريق، مع دراسة التوزيع الأمثل للمسارات وتحديد المواقع المناسبة للإشارات والعلامات المرورية.',
        'التصميم الهندسي للاتصال بالطريق السريع: تطوير الحلول الهندسية لربط الطريق مع الطريق السريع المجاور بشكل يضمن التنقل السلس بين الطرق مع تقليل التأثيرات على حركة المرور الحالية.',
      ],
      points: [
        {point:'الاعتبارات البيئية',
          text:'مراعاة التأثيرات البيئية خلال التصميم لضمان الحفاظ على البيئة الطبيعية في منطقة نيوم بما يتماشى مع رؤية المشروع الساعية للتنمية المستدامة.',
        }
      ],
      execution_year: null,
      start_date: null,
      images: [projectInfra6_1,projectInfra6_2,projectInfra6_3,projectInfra6_4]
    },
    {
      id: '96633',
      name: 'تصميم شبكات الري والبنية التحتية لمشروع الرياض الخضراء (المنطقة الثالثة)',
      category: { id: 10, name: t("navInfrastructure")},
      customer: '',
      text: 'في إطار مشاركتنا في مشروع الرياض الخضراء، قام فريق عمل المكيال السعودي للاستشارات الهندسية بتقديم حلول هندسية متكاملة لتصميم شبكات الري وأعمال البنية التحتية للمنطقة الثالثة من المشروع. تمحور عمل الفريق حول تطوير أنظمة ري مبتكرة ومستدامة لدعم الخضرة والنمو النباتي.',
      text2: 'يساهم هذا العمل في دعم أهداف مشروع الرياض الخضراء من خلال توفير حلول هندسية مبتكرة تعزز من استدامة البيئة الحضرية وتدعم رؤية العاصمة في التحول إلى مدينة أكثر اخضرارًا.',
      work_scope: '',
      work_scope_points: [
        'تصميم شبكات الري: تطوير وتصميم شبكات ري حديثة وفعالة لتغطية المناطق الخضراء بما يضمن استدامة الري مع مراعاة كفاءة استهلاك المياه',
        'أعمال الهندسة الكاملة للبنية التحتية: تصميم البنية التحتية اللازمة لدعم تنفيذ الشبكات، بما في ذلك الأنابيب والمكونات المختلفة لضمان الأداء الأمثل.',
        'نظام الإسكادا: تطوير وتطبيق نظام التحكم الآلي (SCADA) لمراقبة وإدارة أنظمة الري عن بعد، مما يضمن تحسين الكفاءة التشغيلية وسهولة التحكم في العمليات.',
        'التصميم التخطيطي لخزانات الري: إعداد التصاميم الهندسية لخزانات الري الرئيسية والثانوية لتوفير مصادر مياه متجددة بشكل مستمر ودون انقطاع.',
        'تصميم الحدائق المستقبلية: تقديم حلول تصميم هندسي لحدائق ومسطحات خضراء مستقبلية، تضمن التنوع البيئي والجمالي للمنطقة.',
      ],
      points: [],
      execution_year: null,
      start_date: null,
      images: [projectInfra7_1]
    },
    {
      id: '96634',
      name:'دراسة التأثير المروري لمستشفيي سليمان الحبيب بحي الحمراء',
      category: { id: 11, name: t("navTransport")},
      customer: '',
      text: '',
      text2: '',
      work_scope: '',
      work_scope_points: [],
      points: [],
      execution_year: null,
      start_date: null,
      images: [projectTrans1_1,projectTrans1_2,projectTrans1_3,projectTrans1_4]
    },
    {
      id: '96635',
      name:'دراسة التأثير المروري لمجمع مدارس جلوري العالمية بحى بدر',
      category: { id: 11, name: t("navTransport")},
      customer: '',
      text: '',
      text2: '',
      work_scope: '',
      work_scope_points: [],
      points: [],
      execution_year: null,
      start_date: null,
      images: [projectTrans2_1,projectTrans2_2,projectTrans2_3,projectTrans2_4]
    },
    {
      id: '96636',
      name:'دراسة التأثير المروري لمشروع يمام بحي السفارات.',
      category: { id: 11, name: t("navTransport")},
      customer: '',
      text: '',
      text2: '',
      work_scope: '',
      work_scope_points: [],
      points: [],
      execution_year: null,
      start_date: null,
      images: [projectTrans3_1,projectTrans3_2,projectTrans3_3,projectTrans3_4]
    },
    {
      id: '96637',
      name:'العقد الموحد للأشراف على أعمال إنشاء وصيانة شبكات التوزيع حتى جهد 36 ك.ف',
      category: { id: 12, name: t("navElectrical")},
      customer: 'الشركة السعودية للكهرباء',
      text: 'في إطار التعاون الاستراتيجي بين المكيال السعودي للاستشارات الهندسية والشركة السعودية للكهرباء، يقوم فريق عمل المكيال السعودي للاستشارات الهندسية بالإشراف على أعمال إنشاء وصيانة شبكات التوزيع حتى جهد 36 ك.ف في مناطق متعددة. يشمل العمل إشرافًا هندسيًا عالي المستوى لضمان تنفيذ المشاريع بكفاءة وجودة وفقًا لأعلى المعايير الفنية.',
      text2: null,
      work_scope: '',
      work_scope_points: [],
      points: [
        {point:'يتضمن النطاق الجغرافي للمشروع المناطق التالية',
        points: [
          {point:'إدارة منطقة الرياض'},
          {point:'إدارة كهرباء الخرج'},
          {point:'إدارة كهرباء الطائف'},
          {point:'القطاع الأوسط'},
          {point:'القطاع الغربي'},
        ]},
        {point:'تمحور عمل الفريق حول',
        points: [
          {point:'إشراف هندسي على إنشاء شبكات التوزيع: ضمان بناء الشبكات وفقًا للمواصفات الفنية المعتمدة، مع التركيز على السلامة والكفاءة في تنفيذ الأعمال'},
          {point:'إشراف على صيانة الشبكات: متابعة أعمال الصيانة الدورية والإصلاحات المطلوبة للحفاظ على استمرارية الخدمة وجودتها، وتقليل أي انقطاعات محتملة في الشبكة'},
        ]},
        {point:'التنسيق مع الشركة السعودية للكهرباء',
        text: 'التعاون المستمر مع فرق العمل المختلفة في الشركة لضمان التكامل بين الأنظمة والمشاريع، ودعم تلبية احتياجات الطاقة المتزايدة في تلك المناطق.'},
      ],
      execution_year: null,
      start_date: null,
      images: [projectElectrical1_1,projectElectrical1_2,projectElectrical1_3,projectElectrical1_4]
    },
    {
      id: '96638',
      name:'دراسة وتقييم الحالة الإنشائية لقصر الملك خالد والمباني المحيطة به في محمية الملك خالد الملكية',
      category: { id: 17, name: t("navEvaluation")},
      customer: 'هيئة تطوير محمية الإمام عبد العزيز بن محمد الملكية',
      text: 'في إطار الحفاظ على التراث المعماري والتاريخي، قام المكيال السعودي للاستشارات الهندسية بتنفيذ دراسة شاملة لتقييم الحالة الإنشائية لقصر الملك خالد والمباني المحيطة به داخل محمية الملك خالد الملكية. يهدف المشروع إلى تحديد حالة المباني من الناحية الإنشائية والتأكد من سلامتها الهيكلية، مع وضع التوصيات اللازمة للحفاظ عليها وترميمها بما يتماشى مع المعايير الفنية والبيئية.',
      text2: null,
      work_scope: 'إجراء الاختبارات والفحوصات لتقييم الحالة الإنشائية لقصر الملك خالد والمباني والملحقات المحيطة به في محمية الملك خالد',
      work_scope_points: [
        'التقييم الإنشائي لقصر الملك خالد: فحص الهيكل الإنشائي للقصر باستخدام أحدث تقنيات الفحص والتقييم لتحديد مدى قوة واستدامة الأساسات والجدران، بالإضافة إلى التحقق من تعرضه لأي مشاكل هيكلية.',
        'دراسة المباني المحيطة: تحليل حالة المباني والمرافق المحيطة بالقصر في المحمية لضمان عدم تأثير أي تدهور على البيئة المحيطة أو على البنية التحتية المعمارية.',
        'التوصيات والترميم: وضع خطة ترميم شاملة تشمل الإجراءات اللازمة لتقوية المباني وحمايتها من أي تدهور مستقبلي، بما في ذلك المواد والأساليب المناسبة للحفاظ على الطابع المعماري الفريد للموقع.',
      ],
      points: [
        {point:'الحفاظ على البيئة',
          text:'مراعاة المعايير البيئية في تنفيذ أعمال التقييم والتوصيات، لضمان الحفاظ على المحمية الطبيعية وحمايتها من أي تأثيرات سلبية'
        }
      ],
      execution_year: null,
      start_date: null,
      images: [projectEvaluation1_1,projectEvaluation1_2,projectEvaluation1_3,projectEvaluation1_4]
    },
    {
      id: '96639',
      name:'دراسة الهيكل الإنشائي لمواقع متعددة بمدينة الملك عبد العزيز العسكرية بتبوك',
      category: { id: 17, name: t("navEvaluation")},
      customer: 'الأشغال العسكرية – وزارة الدفاع ',
      text: '',
      text2: null,
      work_scope: 'إجراء اختبارات وفحوصات وعمل دراسة للهيكل الإنشاء لمواقع متعددة بمدينة الملك عبد العزيز العسكرية بتبوك',
      work_scope_points: [],
      points: [],
      execution_year: null,
      start_date: null,
      images: [projectEvaluation2_1,projectEvaluation2_2,projectEvaluation2_3,projectEvaluation2_4]
    },
    {
      id: '96640',
      name:'تقييم إنشائي لمبنى العزاب بالمركز الرئيسي للمؤسسة العامة لتحلية المياه المالحة والمبنى الإداري بالتخصصي في الرياض',
      category: { id: 17, name: t("navEvaluation")},
      customer: 'الهيئة السعودية للمياه (المؤسسة العامة لتحلية المياه المالحة سابقاً)',
      text: '',
      text2: null,
      work_scope: 'تقييم إنشائي وأعداد دراسة بالحالة الإنشائية',
      work_scope_points: [],
      points: [],
      execution_year: null,
      start_date: null,
      images: [projectEvaluation3_1,projectEvaluation3_2,projectEvaluation3_3]
    },
  ]
  
  const labProjects = [
    {
      id: '9661',
      category: { id: 3, name: t("navGeotechnicalProject")},
      name: t('projects1.1.name')||null,
      customer: t('projects1.1.customer')||null,
      work_scope: t('projects1.1.workScope')||null,
      geographical_scope: t('projects1.1.geographicalScope')||null,
      execution_year:'2024',
      start_date: null,
      status: null,
      description: t('projects1.1.description')||null,
      images: [project1_1,project1_2,project1_3]
    },
    {
      id: '9662',
      category: { id: 3, name: t("navGeotechnicalProject")},
      name: t('projects1.2.name')||null,
      customer: t('projects1.2.customer')||null,
      work_scope: t('projects1.2.workScope')||null,
      geographical_scope: t('projects1.2.geographicalScope')||null,
      execution_year:'2020',
      start_date: null,
      status: null,
      description: t('projects1.2.description')||null,
      images: [project2_1,project2_2,project2_3]
    },
    {
      id: '9663',
      category: { id: 3, name: t("navGeotechnicalProject")},
      name: t('projects1.3.name')||null,
      customer: t('projects1.3.customer')||null,
      work_scope: t('projects1.3.workScope')||null,
      geographical_scope: null,
      execution_year:'2023',
      start_date: null,
      status: null,
      description: t('projects1.3.description')||null,
      images: [project3_1,project3_2,project3_3]
    },
    {
      id: '9664',
      category: { id: 3, name: t("navGeotechnicalProject")},
      name: t('projects1.4.name')||null,
      customer: t('projects1.4.customer')||null,
      work_scope: t('projects1.4.workScope')||null,
      geographical_scope: null,
      execution_year:'2024',
      start_date: null,
      status: null,
      description: t('projects1.4.description')||null,
      images: [project4_1,project4_2,project4_3]
    },
    {
      id: '9665',
      category: { id: 4, name: t("navQualityProject")},
      name: t('projects1.5.name')||null,
      customer: t('projects1.5.customer')||null,
      work_scope: t('projects1.5.workScope')||null,
      geographical_scope: null,
      execution_year: null,
      start_date:'22/05/2024',
      status: t('projects1.5.status')||null,
      description: t('projects1.5.description')||null,
      images: [project5_1,project5_2,project5_3,project5_4,project5_5,project5_6,project5_7,project5_8]
    },
    {
      id: '9666',
      category: { id: 4, name: t("navQualityProject")},
      name: t('projects1.6.name')||null,
      customer: t('projects1.6.customer')||null,
      work_scope: t('projects1.6.workScope')||null,
      geographical_scope: null,
      execution_year: null,
      start_date:'01/08/2024',
      status: t('projects1.6.status')||null,
      description: t('projects1.6.description')||null,
      images: [project6_1,project6_2,project6_3]
    },
    {
      id: '9667',
      category: { id: 14, name: t("navBuildingProject")},
      name: t('projects1.7.name')||null,
      customer: t('projects1.7.customer')||null,
      work_scope:  t('projects1.7.workScope')||null,
      geographical_scope: null,
      execution_year:'2022',
      start_date: null,
      status: null,
      description: t('projects1.7.description')||null,
      images: [project7_1,project7_2,project7_3]
    },
    {
      id: '9668',
      category: { id: 14, name: t("navBuildingProject")},
      name: t('projects1.8.name')||null,
      customer: t('projects1.8.customer')||null,
      work_scope:  t('projects1.8.workScope')||null,
      geographical_scope: t('projects1.8.geographicalScope')||null,
      execution_year:'2021',
      start_date: null,
      status: null,
      description: t('projects1.8.description')||null,
      images: [project8_1,project8_2,project8_3]
    },
    {
      id: '9669',
      category: { id: 14, name: t("navBuildingProject")},
      name: t('projects1.9.name')||null,
      customer: t('projects1.9.customer')||null,
      work_scope:  t('projects1.9.workScope')||null,
      geographical_scope: t('projects1.9.geographicalScope')||null,
      execution_year:'2023',
      start_date: null,
      status: null,
      description: t('projects1.9.description')||null,
      images: [project9_1,project9_2,project9_3]
    },
    {
      id: '96610',
      category: { id: 4, name: t("navQualityProject")},
      name: t('projects1.10.name')||null,
      customer: t('projects1.10.customer')||null,
      work_scope:  t('projects1.10.workScope')||null,
      geographical_scope: t('projects1.10.geographicalScope')||null,
      execution_year: null,
      start_date: null,
      status: t('projects1.10.status')||null,
      description: t('projects1.10.description')||null,
      images: [project10_1,project10_2,project10_3]
    },
  ]

  const getAllProjects = async() => {
    setLoading(true)
    let {data} = await api.get('/projects',
      {params: { type: (site==="company"? "consultancy":"") }}
    )
    setProjects(data)
    setLoading(false)   
  }
  
  const getProjectDetails = async() => {
    setLoading(true)
    let {data} = await api.get(`/projects/${id}`)
    setProject(data) 
    setLoading(false)   
  }
  const getLabProjectDetails = (id) => {
    const selectedProject = labProjects.find((project) => project.id === id)
    setProject(selectedProject) 
  }

  const getCompanyProjectDetails = (id) => {
    const selectedProject = companyProjects.find((project) => project.id === id)
    setProject(selectedProject) 
  }

  const getRelatedProjects = () => {
    const all = [ ...companyProjects, ...labProjects, ...projects]
    const related = all.filter(
      (relatedProject) => Number(relatedProject.category.id) === Number(project?.category.id) && Number(relatedProject.id) !== Number(project.id))
    setRelatedProjects(related)
    
  }

  useEffect(() => {
    getAllProjects()
    if(id.startsWith('966')){
      if(site==='company'){
          getCompanyProjectDetails(id)
        }else{
          getLabProjectDetails(id)
        }
    } else{
        getProjectDetails()  
    }
    
  },[id])

  useEffect(()=>{
    if (project&&projects){
      getRelatedProjects()
    }
  },[id,project,projects])

  const getLocalized = (value) => {
    if (!value) return ''
    if (typeof value === 'string') return value
    return value[language] ?? value['en'] ?? value['ar'] ?? ''
  }

  
  return <>
    {!loading &&project? <>
      <Helmet>
        <title>{getLocalized(project.name)}</title>
      </Helmet>
    
    <div dir={language==='en'? '':'rtl'}>
                                        {/* header */}
      <div className="header-img py-5">
        <div className='w-90 mx-auto d-flex h-100 flex-column align-items-center justify-content-center'>
          {site==='company'? '':<p className='position-relative line text-center fs-2 fw-bold text-black d-flex align-items-center justify-content-center pb-3 mt-3 mb-5'>{t('projectHeader')}</p>}
          <div className={`flex-wrap justify-content-center ${site==='company'? 'lh-md fw-bold d-flex fs-5':'d-md-flex d-none'}`}>
            <Link to={'/'}className='text-hover trans3'>{t('navHome')}<span className='text-black'>&nbsp;/&nbsp;</span></Link>
            <Link to={`/projects/${project.category.id}`} className='text-hover trans3 text-nowrap'>{getLocalized(project.category.name)}<span className='text-black'>&nbsp;/&nbsp;</span></Link>
            <p className='text-secondary text-center'>{getLocalized(project.name)}</p>
          </div>
        </div>
      </div>         
                                        {/* content */}
      <div className="container-lg w-90 mx-auto py-5">
        {site==='company'? <div className='row justify-content-center gy-4'>
          {project.customer['ar']===null &&
          project.execution_year===null &&
          project.start_date===null &&
          project.text['ar']===null &&
          project.text2===null &&
          project.work_scope['ar']===null &&
          project.work_scope_points.length===0 &&
          project.points?.['en']?.[0]?.point?.[language] &&
          project.points?.['en']?.[0]?.text?.[language]
            ? '':<div className="col-xl-6 col-lg-5">
            <div className='border rounded-3 p-4'>
              <div>
                <p className='fw-bold fs-5 text-center'>{getLocalized(project.name)}</p>
                {project.customer['ar']===null? '':<div className='d-lg-flex justify-content-start text-secondary pt-4 text-justify'>
                  <span className={`text-nowrap fw-bold ${language==='en'? 'pe-2':'ps-2'}`}>{t('projectDetails.customer')}</span>
                  <span className='fw-medium'>{getLocalized(project.customer)}</span>
                </div>}
                {project.execution_year===''? '':<div className='d-lg-flex justify-content-start text-secondary pt-4'>
                  <span className={`text-nowrap fw-bold ${language==='en'? 'pe-2':'ps-2'}`}>{t('projectDetails.executionYear')}</span>
                  <span className='fw-medium'>{project.execution_year}</span>
                </div>}
                </div>
                
                <hr className='border-secondary-subtle opacity-100 my-4' />
              {project.text[language]===null? '':<p className='py-3 text-justify'>{getLocalized(project.text)}</p>}
              {(project.work_scope?.['ar'] !== null || (project.work_scope_points?.length > 0 && project.work_scope_points[0]?.[language])) ? <>
                <div>
                  <p className={`text-nowrap fw-bold text-secondary pt-3 ${language === 'en' ? 'pe-2' : 'ps-2'}`}>
                    {t('projectDetails.workScope')}
                  </p>
                  <p className='fw-medium py-2 text-justify'>{getLocalized(project.work_scope)}</p>
                </div>
                <ul className={`list-style-disc ${language === 'en' ? 'ps-4 pe-0' : 'pe-4 ps-0'}`}>
                  {project.work_scope_points?.map((point, index) => <li key={index} className='py-2 text-justify'>
                      {getLocalized(point)}
                    </li>)}
                </ul>
              </>: ''}
                {project.points?.['en']?.map((point,index) =><div key={index}>
                  {point?.point?.[language]? <p className={`text-nowrap pt-3 pb-2 fw-bold text-secondary ${language==='en'? 'pe-2':'ps-2'}`}>{getLocalized(point.point)} :</p>:''}
                  <p className='fw-medium text-justify'>{getLocalized(point.text)}</p>
                    <ul className={`list-style-disc ${language==='en'? 'ps-4 pe-0':'pe-4 ps-0'}`}>
                    {/* {point.points?.map((point,index) => <li key={index} className='py-2'>{point.point}</li>)} */}
                  </ul>
                </div>)}
                {project.text2===null? '':<p className='text-justify'>{project.text2}</p>}
              </div>
          </div>}
          {project.customer['ar']===null && project.execution_year==='' && project.start_date==='' && project.text==='' && project.text2==='' && project.work_scope===''&& project.work_scope_points.length===0 && project.points.length===0? <p className={`fw-bold fs-5 pb-4 ${language==='en'? '':'text-end'}`}>{project.name}</p>:''}
          {project.images.length===0? '':<div className="col-xl-6 col-lg-7">
          <div>
              <Swiper className="cursor-grab pb-5"
                modules={[Autoplay, Pagination]}
                slidesPerView={1}
                autoplay={{
                  delay: 1000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }}
                speed={2000}
                pagination={{
                  clickable: true,
                }}
                dir='ltr'
              >
                {project.images?.map((image ,index) => <SwiperSlide key={index} className='portrait d-flex justify-content-center overflow-hidden'>
                  <img loading='lazy' className='object-cover h-100' src={image} alt={project.name} />
                </SwiperSlide>)}
              </Swiper>
            </div>
          </div>}
          </div> :<div className='row gy-4 justify-content-center'>
          {project.images.length===0? '':<div className="col-xl-7 col-lg-6 col-md-7">
            <div>
              <Swiper className="cursor-grab pb-5"
                  modules={[Autoplay, Pagination]}
                  slidesPerView={1}
                  autoplay={{
                    delay: 1000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                  }}
                  speed={2000}
                  pagination={{
                    clickable: true,
                  }}
                  dir='ltr'
                >
                  {project.images?.map((image ,index) => <SwiperSlide key={index} className='portrait'>
                    <img loading='lazy' className='object-cover h-100' src={image} alt={project.name} />
                  </SwiperSlide>)}
                </Swiper>
              </div>
          </div>}
          <div className="col-xl-5 col-lg-6 col-md-5">
            <div className='border rounded-3 p-4'>
              <div>
                <p className='fw-bold fs-5 text-center'>{getLocalized(project.name)}</p>
                {project.customer['ar']===null? '':<div className='d-lg-flex justify-content-between text-secondary pt-4'>
                  <span className={`text-nowrap fw-bold ${language==='en'? 'pe-2':'ps-2'}`}>{t('projectDetails.customer')}</span>
                  <span className='fw-medium text-justify'>{getLocalized(project.customer)}</span>
                </div>}
                {project.work_scope['ar']===null? '':<div className='d-lg-flex justify-content-between text-secondary pt-4'>
                  <span className={`text-nowrap fw-bold ${language==='en'? 'pe-2':'ps-2'}`}>{t('projectDetails.workScope')}</span>
                  <span className='fw-medium text-justify'>{getLocalized(project.work_scope)}</span>
                </div>}
                {project.geographical_scope===null? '':<div className='d-lg-flex justify-content-between text-secondary pt-4'>
                  <span className={`text-nowrap fw-bold ${language==='en'? 'pe-2':'ps-2'}`}>{t('projectDetails.geographicalScope')}</span>
                  <span className='fw-medium text-justify'>{project.geographical_scope}</span>
                </div>}
                {project.execution_year===null? '':<div className='d-lg-flex justify-content-between text-secondary pt-4'>
                  <span className={`text-nowrap fw-bold ${language==='en'? 'pe-2':'ps-2'}`}>{t('projectDetails.executionYear')}</span>
                  <span className='fw-medium'>{project.execution_year}</span>
                </div>}
                {project.start_date===null? '':<div className='d-lg-flex justify-content-between text-secondary pt-4'>
                  <span className={`text-nowrap fw-bold ${language==='en'? 'pe-2':'ps-2'}`}>{t('projectDetails.startDate')}</span>
                  <span className='fw-medium'>{project.start_date}</span>
                </div>}
                {project.status===null? '':<div className='d-lg-flex justify-content-between text-secondary pt-4'>
                  <span className={`text-nowrap fw-bold ${language==='en'? 'pe-2':'ps-2'}`}>{t('projectDetails.status')}</span>
                  <span className='fw-medium'>{project.status}</span>
                </div>}
              </div>
              <div>
                {relatedProjects.length===0? '':<>
                  <hr className='border-secondary-subtle opacity-100 my-4' />
                  <p className='fw-bold fs-5 pb-3'>{t('related')}</p>
                  </>}
                {relatedProjects.map((relatedProject) => <Link key={relatedProject.id} to={`/projectDetails/${relatedProject.id}`} className="row gx-3 py-3 project">
                  <div className="col-xl-2 col-lg-3 col-md-4 col-sm-2 col-3">
                    <div className='square overflow-hidden rounded-1'>
                      <img loading='lazy' className='w-100 h-100' src={(relatedProject.images.length > 0 ? relatedProject.images[0] : labsLogo)} alt={getLocalized(relatedProject.name)} />
                    </div>
                  </div>
                  <div className="col-xl-10 col-lg-9 col-md-8 col-sm-10 col-9 d-flex align-items-sm-start align-items-center">
                    <div>
                      <p className='fw-semibold text-hover trans3 text-justify'>{getLocalized(relatedProject.name)} </p>
                      <p className='text-secondary pt-2 small d-sm-flex d-none'>{getLocalized(project.category?.name)}</p>
                    </div>
                  </div>
                </Link>)}
              </div>
            </div>
          </div>
          </div>}
        </div>
      {site==='company' && relatedProjects.length > 0 ?<div className="bg-light">
        <div className="container-lg w-90 mx-auto py-5">
          <p className='fw-bold fs-5 pb-3'>{t('related')}</p>
          <div className="row">
            {relatedProjects?.map((relatedProject) => <Link key={relatedProject.id} to={`/projectDetails/${relatedProject.id}`} className="row gx-3 py-3 project col-lg-4 col-sm-6">
              <div className="col-xl-2 col-md-3 col-sm-4 col-3">
                <div className='square overflow-hidden rounded-1'>
                  <img loading='lazy' className='w-100 h-100' src={relatedProject.images.length > 0 ? relatedProject.images[0] : engLogo} alt={getLocalized(relatedProject.name)} />
                </div>
              </div>
              <div className="col-xl-10 col-md-9 col-sm-8 col-9 d-flex align-items-sm-start align-items-center">
                <div>
                  <p className='fw-semibold text-hover trans3 text-justify'>{getLocalized(relatedProject.name)} </p>
                  <p className='text-secondary pt-2 small d-sm-flex d-none'>{getLocalized(project.category?.name)}</p>
                </div>
              </div>
            </Link>)}
          </div>
        </div>
      </div>:''}
    </div>
    </>:<LoadingP />
    }     
  </>
}

